import getProvider from './get-provider';

export default getProvider;
